import { Injectable, signal, WritableSignal } from "@angular/core";
import {
  ApiTransaction,
  DiscountRequestType,
  ExternalTransaction,
  ItemDetail,
  ItemDetailsComplete,
  PosApiConfig,
  PosAppConfig,
} from "./model/pos.api.model";
import { isObservable, Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})

//AppContext service holds context data which are available for all the components
export class AppContext {
  posAppConfig: PosAppConfig;

  public foundCustomer: boolean = false;
  public currentTransaction: ApiTransaction;
  public showPromotionsDialog: boolean = false;
  public scannerComponentCode: string | undefined = undefined;
  public contextData: { [key: string]: any } = {};
  public customerSelectedTransaction: ApiTransaction | undefined = undefined;
  public customerSelectedReservation: ExternalTransaction | undefined =
    undefined;
  public ipAddress: string = "localhost";
  public navigatedFrom: string | undefined = undefined;
  public offlineCounter: number = 0;
  public discountType: DiscountRequestType | undefined = undefined;
  public confirmVoidTrans: boolean = false;
  public transactionHasPayment: boolean = false;
  public paymentWithCardFailed: boolean = false;
  public fullyPaidWindow: boolean = false;
  public confirmWindowValue: boolean = false;
  public paymentRemoveConfirmWindow: boolean = false;
  public paymentRemoveConfirm: boolean = false;
  public confirmWindowFinish: boolean = false;
  public discountValueWindow: boolean = false;
  public rechargeValueWindow: boolean = false;
  public scannerActiveWindow: boolean = false;
  public passwordChangeWindow: boolean = false;
  public loginScannerWindow: boolean = false;
  public searchCustomerWindow: boolean = false;
  public variantsActive: boolean = false;
  public manualDiscounts: boolean = false;
  public isBasketDiscount: boolean = false;
  public currentPage = "";
  public posApiConfig: PosApiConfig | undefined = undefined;
  public allowCashPayment: boolean = localStorage.getItem("allowCashPayment")
    ? localStorage.getItem("allowCashPayment") == "1"
      ? true
      : false
    : false || false;
  public variantUpdate: {
    update?: boolean;
    currentVariant?: ItemDetail;
    itemID?: number;
    num?: number;
    selectedVariant?: string;
  } = {};

  public useSelfPrinter: boolean = localStorage.getItem("useSelfPrinter")
    ? localStorage.getItem("useSelfPrinter") == "1"
      ? true
      : false
    : false || false;
  public useSelfPayment: boolean = localStorage.getItem("useSelfPayment")
    ? localStorage.getItem("useSelfPayment") == "1"
      ? true
      : false
    : false || false;
  public disableTerminalPrint: boolean = localStorage.getItem(
    "disableTerminalPrint"
  )
    ? localStorage.getItem("disableTerminalPrint") == "1"
      ? true
      : false
    : false || false;

  public currentVariants: ItemDetailsComplete | undefined = undefined;
  public customerWindow: boolean = false;
  public cameraSettings: boolean = false;
  public terminalMessage: string = "";
  public canFinishTransaction: boolean = false;
  public hasProducts: boolean = false;
  public isFocused: number = null;
  public isConnected: boolean = true;
  public sideBarLock: boolean = false;
  public transContext: TransactionContext = new TransactionContext();

  private goBackSource = new Subject<void>();
  goBack$ = this.goBackSource.asObservable();

  private refreshTransactionSource = new Subject<void>();
  refreshTransaction$ = this.refreshTransactionSource.asObservable();

  private refreshTransactionDetailSource = new Subject<void>();
  refreshTransactionDetail$ =
    this.refreshTransactionDetailSource.asObservable();

  private showPromotionDialogSource = new Subject<void>();
  showPromotionDialog$ = this.showPromotionDialogSource.asObservable();

  constructor() {
    const savedContent = localStorage.getItem("appContext");
    if (savedContent) {
      this.copyMatchingProperties(this, JSON.parse(savedContent));
    }
  }

  copyMatchingProperties(target, source) {
    Object.keys(source).forEach((key) => {
      if (key in target) {
        //check if the object isn't subject or it's connected to it
        if (
          source[key]?._isScalar !== false &&
          source[key]?.observers === undefined &&
          !isObservable(source[key]) &&
          !key.includes("$") &&
          typeof source[key] != "function"
        ) {
          target[key] = source[key];
        }
      }
    });
  }

  goBack() {
    this.goBackSource.next();
  }

  refreshTransaction() {
    this.refreshTransactionSource.next();
  }

  refreshTransactionDetail() {
    this.refreshTransactionDetailSource.next();
  }

  showPromotionDialog() {
    this.showPromotionDialogSource.next();
  }

  public clearStorage() {
    this.customerSelectedReservation = null;
    this.customerSelectedTransaction = null;
    this.transactionHasPayment = false;
    this.navigatedFrom = "";
    this.scannerComponentCode = "";
    this.transContext.title = "";
    this.save();
  }

  public save() {
    localStorage.setItem(
      "appContext",
      JSON.stringify(this.removeCircularReferences(this))
    );
  }

  private removeCircularReferences(obj: any) {
    const seen = new WeakSet();
    return JSON.parse(
      JSON.stringify(obj, (key, value) => {
        if (typeof value === "object" && value !== null) {
          if (seen.has(value)) {
            return; // Discard circular references
          }
          seen.add(value);
        }
        return value;
      })
    );
  }

  public async confirmWindow() {
    this.confirmWindowValue = !this.confirmWindowValue;
    return this.confirmWindowValue;
  }

  public async removePaymentsWindow() {
    this.paymentRemoveConfirmWindow = !this.paymentRemoveConfirmWindow;
    return this.paymentRemoveConfirmWindow;
  }
}

export class TransactionContext {
  public title: string;
}
